import { useTranslation } from 'react-i18next';
import { useTheme } from '@/shared/ui/theme/ThemeProvider';
import { Modal } from '@/shared/ui/components/Modal';
import { useDeviceLicenseState } from '../context/DeviceLicenseContext';
import { useAuth } from '@/modules/auth/presentation/context/AuthContext';

const COPY_KEY: Record<'exceeded' | 'not-found' | 'unknown', string> = {
  exceeded: 'deviceLicense.exceeded',
  'not-found': 'deviceLicense.notFound',
  unknown: 'deviceLicense.unknown',
};

/** Blocking, non-dismissable modal — forces logout on any license re-check failure. */
export function DeviceLicenseModal() {
  const { t } = useTranslation('common');
  const { T, C } = useTheme();
  const { licenseError, setLicenseError } = useDeviceLicenseState();
  const { logout } = useAuth();

  if (licenseError === null) return null;

  const i18nKey = COPY_KEY[licenseError];

  const handleAccept = () => {
    logout();
    setLicenseError(null);
  };

  return (
    <Modal open={true} onClose={() => {}} zIndex={10000}>
      <div style={{ padding: 28, textAlign: 'center' }}>
        <h2 style={{ fontSize: 16, fontWeight: 700, color: T.text, marginBottom: 8 }}>
          {t(`${i18nKey}.title`)}
        </h2>
        <p style={{ fontSize: 12, color: T.textMuted, marginBottom: 20, lineHeight: 1.6 }}>
          {t(`${i18nKey}.subtitle`)}
        </p>
        <button
          onClick={handleAccept}
          style={{
            width: '100%',
            padding: '12px 20px',
            borderRadius: 10,
            border: 'none',
            background: C.blue,
            color: '#fff',
            fontFamily: 'inherit',
            fontSize: 13,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          {t(`${i18nKey}.accept`)}
        </button>
      </div>
    </Modal>
  );
}
